export enum ImageTabs {
  MARKETER = 'MARKETER',
  ARTICLE = 'ARTICLE',
  AI_GENERATED = 'AI_GENERATED'
}
